import React, { createContext, useContext, useEffect, useState } from "react";

const BrandContext = createContext(null);

export function BrandProvider({ children }) {
  const [brand, setBrand] = useState(() => localStorage.getItem("ggg_active_brand") || "GGG");
  useEffect(() => {
    localStorage.setItem("ggg_active_brand", brand);
  }, [brand]);
  return <BrandContext.Provider value={{ brand, setBrand }}>{children}</BrandContext.Provider>;
}

export function useBrand() {
  return useContext(BrandContext);
}
